import { ProductListItem } from '@shared/model/product';
import { IOption } from '@vtbhome/juicyfront/types';

export const selectedProductId = (fieldValue: IOption[] | undefined, products: ProductListItem[] | undefined) => {
    if (!fieldValue || !fieldValue.length || !products || !products.length) {
        return;
    }
    return products.find((product) => product.code === fieldValue[0].value)?.id;
};
